import { createApp } from "vue"
import App from "./App.vue"
import { Router } from "./router/router"

import ElementPlus from "element-plus"
import "element-plus/dist/index.css"
import locale from "element-plus/lib/locale/lang/zh-cn";
import * as ElementPlusIconsVue from "@element-plus/icons-vue"

import "./assets/css/public.css";

const app = createApp(App);

//加载element-plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(Router).use(ElementPlus,{locale}).mount("#app");
